module.exports = __webpack_public_path__ + "static/media/g2.010e36a5.jpg";